import { c as _c } from "react/compiler-runtime";
import { mergeClasses } from '@/utils/style';
import { FieldRenderProps } from 'react-final-form';
import { ErrorMessage } from '../ErrorMessage';
import { useTranslation } from 'react-i18next';
type Field = FieldRenderProps<string, HTMLInputElement> & {
  label: string;
};
export function SwitchInput(props) {
  const $ = _c(30);
  const hasError = props.meta.error && props.meta.touched;
  const errorId = `${props.input.name}-error`;
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = ["core"];
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    t
  } = useTranslation(t0);
  let t1;
  if ($[1] !== props.className) {
    t1 = mergeClasses(props.className);
    $[1] = props.className;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const t2 = props.hideLabel ? props.label : "";
  const t3 = hasError ? errorId : undefined;
  const t4 = hasError ? "true" : "false";
  const t5 = props.input.checked || props.input.value;
  let t6;
  if ($[3] !== props.input || $[4] !== props.label || $[5] !== t2 || $[6] !== t3 || $[7] !== t4 || $[8] !== t5) {
    t6 = <input {...props.input} type="checkbox" placeholder={t2} aria-label={props.label} aria-describedby={t3} aria-invalid={t4} id={props.input.name} className="peer sr-only opacity-0" checked={t5} />;
    $[3] = props.input;
    $[4] = props.label;
    $[5] = t2;
    $[6] = t3;
    $[7] = t4;
    $[8] = t5;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== props.input.checked || $[11] !== props.input.value || $[12] !== t) {
    t7 = props.input.checked || props.input.value ? t("forms.switch.on") : t("forms.switch.off");
    $[10] = props.input.checked;
    $[11] = props.input.value;
    $[12] = t;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== t7) {
    t8 = <span className="sr-only">{t7}</span>;
    $[14] = t7;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  let t9;
  if ($[16] !== props.input.name || $[17] !== t8) {
    t9 = <label htmlFor={props.input.name} className="relative flex h-6 w-11 cursor-pointer items-center rounded-full bg-gray-200 px-0.5 outline-gray-400 transition-colors peer-checked:bg-green-500 peer-focus-visible:outline peer-focus-visible:outline-offset-2 peer-focus-visible:outline-gray-400 peer-focus-visible:peer-checked:outline-green-500 peer-disabled:pointer-events-none peer-disabled:opacity-60 before:h-5 before:w-5 before:rounded-full before:bg-white before:shadow-sm before:transition-transform before:duration-300 peer-checked:before:translate-x-full">{t8}</label>;
    $[16] = props.input.name;
    $[17] = t8;
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  let t10;
  if ($[19] !== t6 || $[20] !== t9) {
    t10 = <div className="flex gap-2" data-clarity-mask="true">{t6}{t9}</div>;
    $[19] = t6;
    $[20] = t9;
    $[21] = t10;
  } else {
    t10 = $[21];
  }
  let t11;
  if ($[22] !== errorId || $[23] !== hasError || $[24] !== props.meta.error) {
    t11 = hasError && <ErrorMessage error={props.meta.error} id={errorId} />;
    $[22] = errorId;
    $[23] = hasError;
    $[24] = props.meta.error;
    $[25] = t11;
  } else {
    t11 = $[25];
  }
  let t12;
  if ($[26] !== t1 || $[27] !== t10 || $[28] !== t11) {
    t12 = <div className={t1}>{t10}{t11}</div>;
    $[26] = t1;
    $[27] = t10;
    $[28] = t11;
    $[29] = t12;
  } else {
    t12 = $[29];
  }
  return t12;
}